import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { PrayerStreamUserStatus } from '../../core/stream/stream.slice';
import { useSelector } from '../../hooks/useSelector';
import { useTranslation } from '../../i18n/resources';
import { Chat } from '../Chat/Chat';
import { Landing } from '../Landing/Landing';
import { LinearLoading } from '../LinearLoading/LinearLoading';
import { PageSection } from '../PageSection/PageSection';
import styles from './PrayerStream.module.css';

export type PrayerStreamProps = {
  className?: string;
};
export const PrayerStream: FunctionComponent<PrayerStreamProps> = ({
  className,
}) => {
  const { t } = useTranslation();
  const { prayerStreamUserStatus } = useSelector((state) => state.stream);
  const { registerPrayerStreamUser } = useSelector(
    (state) => state.asyncAction,
  );

  const showLoading =
    registerPrayerStreamUser.pending &&
    registerPrayerStreamUser.status === null;

  if (showLoading) {
    return (
      <PageSection>
        <LinearLoading
          description={t('loading', 'message')}
          showBibleVerse
          showLogo
        />
      </PageSection>
    );
  }

  const userRegistered =
    prayerStreamUserStatus === PrayerStreamUserStatus.REGISTERED;

  return (
    <div className={cx(className, styles.root)}>
      {!userRegistered && <Landing />}
      {userRegistered && <Chat />}
    </div>
  );
};
